export default {
  desc: {
    display: 'block',
    fontSize: 12,
    textTransform: 'none'
  },
  descWrapper: {
    display: 'block',
    fontSize: 14,
    textTransform: 'none'
  },
  icon: {
    marginRight: 10,
    fontSize: 22,
    fill: '#363636',
    '& path': {
      fill: '#363636'
    }
  },
};